<h1 mat-dialog-title>{{caption}}</h1>

<div mat-dialog-content>
  <form class="example-form">

    <mat-form-field style="width: 100%;">
      <mat-select [(ngModel)]='this.forecast.customer_id' [ngModelOptions]="{standalone: true}" [disabled]="true">
        @for (c of customers; track c) {
          <mat-option [value]="c.id">
            {{c.name}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <lf-select-search [listElements]="suppliers" placeholder="GA Supplier (No. / Name) *"
      placeholderLabel="supplier" (selected)="this.supplierChanged($event)" [disabled]="!this.allowEdit"
      [selectedElementId]="forecast.supplier_id" />

    <lf-select-search [listElements]="items" placeholder="Item *" placeholderLabel="item"
      (selected)="this.itemChanged($event)" [selectedElementId]="forecast.item_id"
      [disabled]="!this.allowEdit" />

    <table>
      <tr>
        <td>
          <mat-form-field class="week-input">
            <mat-label>{{weeks[0]}}</mat-label>
            <input matInput [(ngModel)]='forecast.wk01'
              [ngModelOptions]="{standalone: true}" [disabled]="weeksDisabled>=1">
            </mat-form-field>
            <mat-form-field class="week-input">
              <mat-label>{{weeks[1]}}</mat-label>
              <input matInput [(ngModel)]='forecast.wk02'
                [ngModelOptions]="{standalone: true}" [disabled]="weeksDisabled>=2">
              </mat-form-field>
              <mat-form-field class="week-input">
                <mat-label>{{weeks[2]}}</mat-label>
                <input matInput [(ngModel)]='forecast.wk03'
                  [ngModelOptions]="{standalone: true}" [disabled]="weeksDisabled>=3">
                </mat-form-field>
                <mat-form-field class="week-input">
                  <mat-label>{{weeks[3]}}</mat-label>
                  <input matInput [(ngModel)]='forecast.wk04'
                    [ngModelOptions]="{standalone: true}" [disabled]="weeksDisabled>=4">
                  </mat-form-field>
                  <mat-form-field class="week-input">
                    <mat-label>{{weeks[4]}}</mat-label>
                    <input matInput [(ngModel)]='forecast.wk05'
                      [ngModelOptions]="{standalone: true}" [disabled]="weeksDisabled>=5">
                    </mat-form-field>
                    <mat-form-field class="week-input">
                      <mat-label>{{weeks[5]}}</mat-label>
                      <input matInput [(ngModel)]='forecast.wk06'
                        [ngModelOptions]="{standalone: true}" [disabled]="weeksDisabled>=6">
                      </mat-form-field>
                      <mat-form-field class="week-input">
                        <mat-label>{{weeks[6]}}</mat-label>
                        <input matInput [(ngModel)]='forecast.wk07'
                          [ngModelOptions]="{standalone: true}" [disabled]="weeksDisabled>=7">
                        </mat-form-field>
                        <mat-form-field class="week-input">
                          <mat-label>{{weeks[7]}}</mat-label>
                          <input matInput [(ngModel)]='forecast.wk08'
                            [ngModelOptions]="{standalone: true}" [disabled]="weeksDisabled>=8">
                          </mat-form-field>
                          <mat-form-field class="week-input">
                            <mat-label>{{weeks[8]}}</mat-label>
                            <input matInput [(ngModel)]='forecast.wk09'
                              [ngModelOptions]="{standalone: true}" [disabled]="weeksDisabled>=9">
                            </mat-form-field>
                          </td>
                          <!--                <td style="border-left: 1px solid red; padding: 1em;">-->
                          <!--                    This part will be excluded from KPI reports-->
                        <!--                </td>-->
                      </tr>
                      <tr>
                        <mat-form-field class="week-input">
                          <mat-label>{{weeks[9]}}</mat-label>
                          <input matInput [(ngModel)]='forecast.wk10' [ngModelOptions]="{standalone: true}"
                            [disabled]="weeksDisabled>=10">
                          </mat-form-field>
                          <mat-form-field class="week-input">
                            <mat-label>{{weeks[10]}}</mat-label>
                            <input matInput [(ngModel)]='forecast.wk11' [ngModelOptions]="{standalone: true}"
                              [disabled]="weeksDisabled>=11">
                            </mat-form-field>
                            <mat-form-field class="week-input">
                              <mat-label>{{weeks[11]}}</mat-label>
                              <input matInput [(ngModel)]='forecast.wk12' [ngModelOptions]="{standalone: true}"
                                [disabled]="weeksDisabled>=12">
                              </mat-form-field>
                              <mat-form-field class="week-input">
                                <mat-label>{{weeks[12]}}</mat-label>
                                <input matInput [(ngModel)]='forecast.wk13' [ngModelOptions]="{standalone: true}"
                                  [disabled]="weeksDisabled>=13">
                                </mat-form-field>
                                <mat-form-field class="week-input">
                                  <mat-label>{{weeks[13]}}</mat-label>
                                  <input matInput [(ngModel)]='forecast.wk14' [ngModelOptions]="{standalone: true}"
                                    [disabled]="weeksDisabled>=14">
                                  </mat-form-field>
                                  <mat-form-field class="week-input">
                                    <mat-label>{{weeks[14]}}</mat-label>
                                    <input matInput [(ngModel)]='forecast.wk15' [ngModelOptions]="{standalone: true}"
                                      [disabled]="weeksDisabled>=15">
                                    </mat-form-field>
                                    <mat-form-field class="week-input">
                                      <mat-label>{{weeks[15]}}</mat-label>
                                      <input matInput [(ngModel)]='forecast.wk16' [ngModelOptions]="{standalone: true}"
                                        [disabled]="weeksDisabled>=16">
                                      </mat-form-field>
                                      <mat-form-field class="week-input">
                                        <mat-label>{{weeks[16]}}</mat-label>
                                        <input matInput [(ngModel)]='forecast.wk17' [ngModelOptions]="{standalone: true}"
                                          [disabled]="weeksDisabled>=17">
                                        </mat-form-field>
                                        <mat-form-field class="week-input">
                                          <mat-label>{{weeks[17]}}</mat-label>
                                          <input matInput [(ngModel)]='forecast.wk18' [ngModelOptions]="{standalone: true}"
                                            [disabled]="weeksDisabled>=18">
                                          </mat-form-field>
                                        </tr>
                                        <tr>
                                          <mat-form-field class="week-input">
                                            <mat-label>{{weeks[18]}}</mat-label>
                                            <input matInput [(ngModel)]='forecast.wk19' [ngModelOptions]="{standalone: true}"
                                              [disabled]="weeksDisabled>=19">
                                            </mat-form-field>
                                            <mat-form-field class="week-input">
                                              <mat-label>{{weeks[19]}}</mat-label>
                                              <input matInput [(ngModel)]='forecast.wk20' [ngModelOptions]="{standalone: true}"
                                                [disabled]="weeksDisabled>=20">
                                              </mat-form-field>
                                              <mat-form-field class="week-input">
                                                <mat-label>{{weeks[20]}}</mat-label>
                                                <input matInput [(ngModel)]='forecast.wk21' [ngModelOptions]="{standalone: true}"
                                                  [disabled]="weeksDisabled>=21">
                                                </mat-form-field>
                                                <mat-form-field class="week-input">
                                                  <mat-label>{{weeks[21]}}</mat-label>
                                                  <input matInput [(ngModel)]='forecast.wk22' [ngModelOptions]="{standalone: true}"
                                                    [disabled]="weeksDisabled>=22">
                                                  </mat-form-field>
                                                  <mat-form-field class="week-input">
                                                    <mat-label>{{weeks[22]}}</mat-label>
                                                    <input matInput [(ngModel)]='forecast.wk23' [ngModelOptions]="{standalone: true}"
                                                      [disabled]="weeksDisabled>=23">
                                                    </mat-form-field>
                                                    <mat-form-field class="week-input">
                                                      <mat-label>{{weeks[23]}}</mat-label>
                                                      <input matInput [(ngModel)]='forecast.wk24' [ngModelOptions]="{standalone: true}"
                                                        [disabled]="weeksDisabled>=24">
                                                      </mat-form-field>
                                                      <mat-form-field class="week-input">
                                                        <mat-label>{{weeks[24]}}</mat-label>
                                                        <input matInput [(ngModel)]='forecast.wk25' [ngModelOptions]="{standalone: true}"
                                                          [disabled]="weeksDisabled>=25">
                                                        </mat-form-field>
                                                        <mat-form-field class="week-input">
                                                          <mat-label>{{weeks[25]}}</mat-label>
                                                          <input matInput [(ngModel)]='forecast.wk26' [ngModelOptions]="{standalone: true}"
                                                            [disabled]="weeksDisabled>=26">
                                                          </mat-form-field>
                                                          <mat-form-field class="week-input">
                                                            <mat-label>{{weeks[26]}}</mat-label>
                                                            <input matInput [(ngModel)]='forecast.wk27' [ngModelOptions]="{standalone: true}"
                                                              [disabled]="weeksDisabled>=27">
                                                            </mat-form-field>
                                                          </tr>
                                                          <tr>
                                                            <mat-form-field class="week-input">
                                                              <mat-label>{{weeks[27]}}</mat-label>
                                                              <input matInput [(ngModel)]='forecast.wk28' [ngModelOptions]="{standalone: true}"
                                                                [disabled]="weeksDisabled>=28">
                                                              </mat-form-field>
                                                              <mat-form-field class="week-input">
                                                                <mat-label>{{weeks[28]}}</mat-label>
                                                                <input matInput [(ngModel)]='forecast.wk29' [ngModelOptions]="{standalone: true}"
                                                                  [disabled]="weeksDisabled>=29">
                                                                </mat-form-field>
                                                                <mat-form-field class="week-input">
                                                                  <mat-label>{{weeks[29]}}</mat-label>
                                                                  <input matInput [(ngModel)]='forecast.wk30' [ngModelOptions]="{standalone: true}"
                                                                    [disabled]="weeksDisabled>=30">
                                                                  </mat-form-field>
                                                                  <mat-form-field class="week-input">
                                                                    <mat-label>{{weeks[30]}}</mat-label>
                                                                    <input matInput [(ngModel)]='forecast.wk31' [ngModelOptions]="{standalone: true}"
                                                                      [disabled]="weeksDisabled>=31">
                                                                    </mat-form-field>
                                                                    <mat-form-field class="week-input">
                                                                      <mat-label>{{weeks[31]}}</mat-label>
                                                                      <input matInput [(ngModel)]='forecast.wk32' [ngModelOptions]="{standalone: true}"
                                                                        [disabled]="weeksDisabled>=32">
                                                                      </mat-form-field>
                                                                      <mat-form-field class="week-input">
                                                                        <mat-label>{{weeks[32]}}</mat-label>
                                                                        <input matInput [(ngModel)]='forecast.wk33' [ngModelOptions]="{standalone: true}"
                                                                          [disabled]="weeksDisabled>=33">
                                                                        </mat-form-field>
                                                                        <mat-form-field class="week-input">
                                                                          <mat-label>{{weeks[33]}}</mat-label>
                                                                          <input matInput [(ngModel)]='forecast.wk34' [ngModelOptions]="{standalone: true}"
                                                                            [disabled]="weeksDisabled>=34">
                                                                          </mat-form-field>
                                                                          <mat-form-field class="week-input">
                                                                            <mat-label>{{weeks[34]}}</mat-label>
                                                                            <input matInput [(ngModel)]='forecast.wk35' [ngModelOptions]="{standalone: true}"
                                                                              [disabled]="weeksDisabled>=35">
                                                                            </mat-form-field>
                                                                          </tr>

                                                                        </table>
                                                                      </form>
                                                                    </div>


                                                                    <div mat-dialog-actions>
                                                                      <button mat-button (click)="onNoClick()">Cancel</button>
                                                                      <button mat-button (click)="onOkClick()" cdkFocusInitial>Ok</button>
                                                                    </div>
